import { render, staticRenderFns } from "./BasicLink.vue?vue&type=template&id=39ee5388"
import script from "./BasicLink.vue?vue&type=script&lang=js"
export * from "./BasicLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports